import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface Props {
  open: boolean;
  instrumentName: string;
  shutdown: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

const ShutdownRebootDialog = ({
  open,
  instrumentName,
  shutdown,
  onSubmit,
  onClose,
}: Props) => {
  const handleSubmit = () => {
    onClose();
    onSubmit();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {shutdown
            ? `Shutdown ${instrumentName}?`
            : `Reboot ${instrumentName}?`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {shutdown
              ? `${instrumentName} will be shutdown on confirmation.`
              : `${instrumentName} will be rebooted on confirmation.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color='secondary' variant='contained'>
            Go Back
          </Button>
          <Button
            onClick={handleSubmit}
            color='primary'
            variant='contained'
            autoFocus
          >
            {shutdown ? 'Shutdown' : 'Reboot'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ShutdownRebootDialog;
